const COLORS = [
  "#1976d2",
  "#388e3c",
  "#d32f2f",
  "#7b1fa2",
  "#f57c00",
  "#0097a7",
  "#5d4037",
  "#455a64",
];

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export function ColorPicker({ value, onChange }: Props) {
  return (
    <div className="color-picker">
      <button
        type="button"
        className={`color-swatch ${!value ? "active" : ""}`}
        style={{ background: "#ccc" }}
        onClick={() => onChange("")}
        title="Use calendar color"
      />
      {COLORS.map((c) => (
        <button
          key={c}
          type="button"
          className={`color-swatch ${value === c ? "active" : ""}`}
          style={{ background: c }}
          onClick={() => onChange(c)}
        />
      ))}
    </div>
  );
}
